import React, { FC } from 'react';
import classes from './styles/index.module.scss';
import classNames from 'classnames';

type StaticHeaderLayoutItemProps = {
	className?: string;
	stretch?: boolean;
};

export const StaticHeaderLayoutItem: FC<React.PropsWithChildren<StaticHeaderLayoutItemProps>> = ({
	className,
	children,
	stretch,
}) => {
	const componentClasses = classNames(classes.staticHeaderItem, className, {
		[classes.staticHeaderItem_stretch]: stretch,
	});

	return <div className={componentClasses}>{children}</div>;
};
